// src/actions/authActions.js
import axios from 'axios';
import { ALL_PRIVILEGE_KEYS } from '../utils/privilegeCatalog';
const base_url  = process.env.REACT_APP_API_URL_ADMIN;

export const login = (username, password, slug) => async (dispatch) => {
  console.log({base_url})
  try {
    const response = await axios.post(`${base_url}`, {
      apiName: 'auth',
      command: 'login',
      username,
      password,
      slug
    });

    // API always returns HTTP 200; status is in the body
    if (response.data?.status !== 200 || !response.data?.data) {
      const message = response.data?.message || 'Login failed';
      const err = new Error(message);
      err.response = { data: { message } };
      throw err;
    }

    const {
      token,
      role,
      companySlug,
      balance,
      balance_check,
      privileges,
      fieldPrivileges,
      userId,
      companyId,
      company_id,
      admin_id,
      super_stokez_id,
      stokez_id,
      agent_id,
      player_id,
    } = response.data.data;
    // Super admin: always store full unrestricted privilege map
    let resolvedPrivileges = privileges || {};
    if (role === 'super_admin' || role === 'superadmin') {
      resolvedPrivileges = {};
      ALL_PRIVILEGE_KEYS.forEach((k) => {
        resolvedPrivileges[k] = true;
      });
    }
    const userPayload = {
      role,
      companySlug,
      balance,
      privileges: resolvedPrivileges,
      fieldPrivileges: fieldPrivileges || {},
      ...(userId ? { userId: String(userId) } : {}),
      ...(companyId || company_id
        ? { companyId: String(companyId || company_id), company_id: String(company_id || companyId) }
        : {}),
      ...(admin_id ? { admin_id: String(admin_id) } : {}),
      ...(super_stokez_id ? { super_stokez_id: String(super_stokez_id) } : {}),
      ...(stokez_id ? { stokez_id: String(stokez_id) } : {}),
      ...(agent_id ? { agent_id: String(agent_id) } : {}),
      ...(player_id ? { player_id: String(player_id) } : {}),
      ...(typeof balance_check === 'boolean' ? { balance_check } : {})
    };
    dispatch({
      type: 'LOGIN_SUCCESS',
      payload: {
        token,
        user: userPayload,
        username
      }
    });
    console.log('auth action >>>' , response.data)
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userPayload));
    localStorage.setItem('username', username);
    localStorage.setItem('isAuthenticated', 'true');

    return { role, companySlug, balance, balance_check, privileges: resolvedPrivileges };
  } catch (error) {
    dispatch({
      type: 'LOGIN_FAIL',
      payload: error.response?.data?.message || error.message || 'Login failed'
    });
    throw error;
  }
};

export const logout = () => (dispatch) => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  dispatch({ type: 'LOGOUT' });
};

export const addUser = (userData) => async (dispatch) => {
  try {
    const response = await axios.post(`${base_url}`, {
      apiName: 'user',
      command: 'addUser',
      ...userData
    });

    dispatch({
      type: 'ADD_USER_SUCCESS',
      payload: response.data.data
    });

    // Refresh the user list
    dispatch(getUsers());

    return response.data;
  } catch (error) {
    dispatch({
      type: 'ADD_USER_FAIL',
      payload: error.response?.data?.message || 'Failed to add user'
    });
    throw error;
  }
};

export const getUsers = () => async (dispatch) => {
  console.log('getUsers action called');
  dispatch({ type: 'GET_USERS_REQUEST' });
  try {
    const response = await axios.post(`${base_url}`, {
      apiName: 'user',
      command: 'getUsers'
    });
    console.log('API response:', response.data);

    dispatch({
      type: 'GET_USERS_SUCCESS',
      payload: response.data.data  // Make sure this matches the API response structure
    });
    console.log('Dispatched GET_USERS_SUCCESS with payload:', response.data.data);
  } catch (error) {
    console.error('Error fetching users:', error);
    dispatch({
      type: 'GET_USERS_FAIL',
      payload: error.response?.data?.message || 'Failed to fetch users'
    });
  }
};
